/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState={
    subdivData:{
        checkedArr:[] ,
        data:[],
        isCheckedAll:[],
        curIndex:0,
        searchVal:'',
        orgId:''
        
    }
    
}
const subdivisionSlice = createSlice({
    name: 'selectedUsers',
    initialState: initialState,
    reducers: {
        addSubdivisions:(state,action)=>{
            state.subdivData.checkedArr[state.selectedUsers.curIndex].push({id:action.payload[0],isChecked:action.payload[1]})
        },
        pushToSubDivArray:(state,action)=>{
            if(action.payload[0]===''){
                state.subdivData.checkedArr.push([])
                state.subdivData.isCheckedAll.push([])
                return
            }else if(action.payload[0]==='emptyEdit'){
                state.subdivData.checkedArr.push(action.payload[1])
                state.subdivData.isCheckedAll.push([])
                return
            }else if(action.payload[0]==='fromObserverFilter'){
                state.subdivData.checkedArr[action.payload[2]]=(action.payload[1]?.map((item)=>({'id':item.subdivision_id,'name':item.sub_division_name,'isChecked':action.payload[3]?.includes(item?.subdivision_id)?true:false,'isEdit':false})))
                state.subdivData.isCheckedAll[action.payload[2]]=(action?.payload[1]?.length===action.payload[3]?.length)?true:false
                return
            }
            if(action.payload[2]!==undefined){
                state.subdivData.checkedArr[action.payload[1]]=(action.payload[0]?.map((item)=>({'id':item.subdivision_id,'name':item.sub_division_name,'isChecked':action.payload[2]?.includes(item?.subdivision_id)?true:false,'isEdit':false})))
                state.subdivData.isCheckedAll[action.payload[1]]=(action?.payload[2]?.length===action.payload[0]?.length)?true:false
                return
            }
            if(state.subdivData.checkedArr[action.payload[1]]===undefined){
                state.subdivData.checkedArr.push(action.payload[0]?.map((item)=>({'id':item.subdivision_id,'name':item.sub_division_name,'isChecked':true})))
                state.subdivData.isCheckedAll.push([true])
            }else{
                state.subdivData.checkedArr[action.payload[1]]=(action.payload[0]?.map((item)=>({'id':item.subdivision_id,'name':item.sub_division_name,'isChecked':true})))
                state.subdivData.isCheckedAll[action.payload[1]]=[true]
            }
            
        },
        popFromSubDivArray:(state,action)=>{
            if(action.payload[0]==='clearall'){
                state.subdivData.checkedArr=[]
                state.subdivData.isCheckedAll=[]
            }else{
                state.subdivData.checkedArr.splice(action.payload[0],1)
                state.subdivData.isCheckedAll.splice(action.payload[0],1)
            }
            
        },
        setSubDivCurIndex:(state,action)=>{
            state.subdivData.curIndex=action.payload[0]
            state.subdivData.orgId=action.payload[1]

        },
        storeDataFromSearch:(state,action)=>{
        
            state.subdivData.data=action.payload[0]?.map((item)=>item?.subdivision_id)
            
        },
        
        toggleSubDivRowSelection: (state, action) => {
            
            let subbdivId=action.payload[0]
            let subdivname=action.payload[2]
            const dataItems=action?.payload[1]
            let isPresentIdInArr=state.subdivData?.checkedArr[state.subdivData.curIndex].find(obj => obj.id === subbdivId);
            if(!isPresentIdInArr){
                state.subdivData.checkedArr[state.subdivData.curIndex].push({'id':subbdivId,'name':subdivname,'isChecked':false})
            }
            let foundObject = state.subdivData?.checkedArr[state.subdivData.curIndex].find(obj => obj.id === subbdivId&&obj.isChecked===true);
            if(foundObject){
                let indexOfObject = state.subdivData?.checkedArr[state.subdivData.curIndex]?.findIndex(obj => obj.id === subbdivId);
                state.subdivData.checkedArr[state.subdivData.curIndex][indexOfObject].isChecked=false

                // Check if the object with the specified id was found
                state.subdivData.isCheckedAll[state.subdivData.curIndex]=false

            }
            else{
                let indexOfObject = state.subdivData?.checkedArr[state.subdivData.curIndex]?.findIndex(obj => obj.id === subbdivId);
                state.subdivData.checkedArr[state.subdivData.curIndex][indexOfObject].isChecked=true
                const allItemsPresent = dataItems?.every(item => state.subdivData.checkedArr[state.subdivData.curIndex]?.some(obj=>obj.id===item?.id&&obj.isChecked===true));
                if(allItemsPresent){
                    state.subdivData.isCheckedAll[state.subdivData.curIndex]=true

                }else{
                    state.subdivData.isCheckedAll[state.subdivData.curIndex]=false
                }
    
            }

        },
        selectAllSubDivRows:(state,action)=>{
            const index=state.subdivData.curIndex
            const data=action.payload[1]
            if(action.payload[0]===false){
                if(action.payload[2]!==undefined && action.payload[2]==="search"){
                    state.subdivData.checkedArr[index].forEach(obj => {
                        data.includes(obj.id)?obj.isChecked=false:''
                    });
                }
                else{
                    state.subdivData.checkedArr[index].forEach(obj => {
                        obj.isChecked=false
                    });
                }
                //state.subdivData.checkedArr[index]=action.payload[1].map((item)=>({'id':item?.id,'name':item?.name!==undefined?item?.name:item?.sub_division_name,'isChecked':false}))
               
                state.subdivData.isCheckedAll[index]=false
            }
            else{
                if(action.payload[2]!==undefined && action.payload[2]==="search"){
                    state.subdivData.checkedArr[index].forEach(obj => {
                        data.includes(obj.id)?obj.isChecked=true:''
                    });
                }
                else{
                    state.subdivData.checkedArr[index].forEach(obj=>{
                        obj.isChecked=true
                    })

                }
                //const newData = action.payload[1]?.map((item) => ({'id':item?.id,'name':item.name,'isChecked':true}));
               
                // Filter out elements that already exist in state.selectedUsers.checkedArr[index]
                

                // Add filtered new objects to the target array
                
                state.subdivData.isCheckedAll[index]=true
            }
            
        },
       
        
        searchSubDivReducer:(state,action)=>{
            const allExistMethod1 = action?.payload[0]?.every((item2) =>
                state.subdivData.checkedArr[action.payload[1]]?.some((item1) => item1.id === item2.id&&item1.isChecked===true)
            )
            if(allExistMethod1){
                state.subdivData.isCheckedAll[action.payload[1]]=true
            }
            else{
                state.subdivData.isCheckedAll[action.payload[1]]=false
            }
            
        },
        searchSubDivValSetter:(state,action)=>{
            state.subdivData.searchVal=action.payload[0]
        },
        fillEmptySubDivArray:(state,action)=>{
            state.subdivData.checkedArr[0]=action.payload[0]?.map((item)=>({"id":item?.subdivision_id,'name':item.sub_division_name,"isChecked":true}))
            if(action.payload[1]!==undefined&&(action.payload[1]===action.payload[0]?.length)){
                state.subdivData.isCheckedAll[0]=true
            }
        },
        resetSubDivList:(state)=>{
            state.subdivData.checkedArr=[], 
            state.subdivData.isCheckedAll=[],
            state.subdivData.curIndex=0,
            state.subdivData.searchVal='',
            state.subdivData.data=[],
            state.subdivData.orgId=''
            

        },
       

    }
});

export const {storeDataFromSearch,fillEmptySubDivArray,resetSubDivList,searchSubDivValSetter,searchSubDivReducer,selectAllSubDivRows,toggleSubDivRowSelection,addSubdivisions,pushToSubDivArray,popFromSubDivArray,setSubDivCurIndex} = subdivisionSlice.actions;
export default subdivisionSlice.reducer;
